import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import Header from '../../components/Header'
import HeaderMobile from '../../components/HeaderMobile'
import HeaderSecondary from '../../components/HeaderSecondary'
import Container from '../../components/Container';
import api from '../../services/api'
import SidebarPage from '../../components/SidebarPage'

import { Editor, EditorState, convertFromRaw } from 'draft-js';


const Row = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 2rem;
    width: 1320px;
    padding-left: 2.7rem;

    .primary{
        font-size: 1.2rem;
        font-family: "Poppins", system-ui;
        font-weight: 500;
    }

    .secondary{
        font-size: 1.0rem;
        line-height: 30px;
        color: #656565;
        font-family: "Poppins", system-ui;
        font-weight: 500;
    }

    @media screen and (max-width:820px){
            padding: 0.9rem;
            width: 100%;
            flex-direction: column;
            align-items: center;

            p{
                text-align: center;
            }
        
    }

`
const CardWrapper = styled.section`
    display: flex;
    width: 1320px;
    padding-left: 2.5rem;
    height: 100%;
    margin: 0 auto;

`
const BannerPage = styled.img`
    margin-top: 0.9rem;
    height: 335px;
    margin-left: 0.9rem;
    object-fit: contain;
`

const About = () => {
    const [editorState, setEditorState] = useState(() => EditorState.createEmpty()); // Estado inicial vazio do Editor
    const [pathName,setPathName] = useState()

    const get = async () => {
        const response = await api.get(`/pages/get/Sobre nós`)
        console.log(response.data)
        if (response.status == 200) {
            const contentState = convertFromRaw(JSON.parse(response.data[0].description));
            setEditorState(EditorState.createWithContent(contentState));

        }
    }

    useEffect(() => {
        get()
    }, [])

    useEffect(() => {

        setPathName(window.location.pathname)

    },[])

    return (
        <Container>
            <Header />
            <HeaderMobile />
            <HeaderSecondary />
            <CardWrapper>
                <SidebarPage/>
                <BannerPage src=''/>

                
            </CardWrapper>
        </Container>
    )
}
export default About